module.exports = __webpack_public_path__ + "static/img/chain-transcation-num.580e099c.png";